module.exports = __webpack_public_path__ + "media/images/sp/stores/karuizawa/karuizawa_sns_01-99f37172a0d97a7ef17dd428c3e3570c.jpg";